export default {"src":"/_next/static/media/Expand.2ffe8931.svg","height":20,"width":20};